/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class ConvertToWIPItemsDialog extends _Ext.ItemEditorDialog<ConvertToWIPItemsRow> {
        protected getFormKey() { return ConvertToWIPItemsForm.formKey; }
        protected getLocalTextPrefix() { return ConvertToWIPItemsRow.localTextPrefix; }
        protected getDeletePermission() { return ConvertToWIPItemsRow.deletePermission; }
        protected getInsertPermission() { return ConvertToWIPItemsRow.insertPermission; }
        protected getUpdatePermission() { return ConvertToWIPItemsRow.updatePermission; }

        public form = new ConvertToWIPItemsForm(this.idPrefix); 

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            //q.HideCategoryLable(this.element);
            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // #endregion

            // #region Field Change Events
            this.form.ItemTypeId.changeSelect2(e => {
                this.Setfields();
            });
            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 3) {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });
            // **** On Weight Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5 && this.form.UnitRate.value > 0) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });

            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.entity.ItemTypeId != 101) {
                    var weight = parseFloat(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    } else {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        }
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value == true) {
                    this.entity.ItemTypeId = 101;
                    this.Setfields();

                } else {
                    this.entity.ItemTypeId = 104;
                    this.Setfields();
                    //this.form.BOMDetails.destroy();

                }
            });
            // **** On NetAmount Change Event ****
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.cascadeField = "CategoryId";
                this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value;

            });

            // **** Set Stone Type in SubType ****
            this.form.ProductTypeId.changeSelect2(e => {

                this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                this.entity.ItemTypeId = this.form.ItemTypeId.value;

                if (this.form.ProductTypeId.value == "11") {
                    this.form.SubCategoryId.cascadeField = "CategoryId";
                    this.form.SubCategoryId.cascadeValue = "124";
                }
                if (this.form.ProductTypeId.value == "12") {
                    this.form.SubCategoryId.cascadeField = "CategoryId";
                    this.form.SubCategoryId.cascadeValue = "125";
                }

                this.Setfields();
                var vouchertypeid = (this.parentEditor.parentDialog as ConvertToWIPDialog).form.VoucherTypeId.value;
                var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == vouchertypeid );

                switch (this.form.ItemTypeId.value) {
                    case 101:
                        this.form.DepartmentId.value = VoucherDetails.DefaultJewelleryDepartment;
                        break;
                    case 104:
                        this.form.DepartmentId.value = VoucherDetails.DefaultMetalDepartment;
                        break;
                    case 105:
                        this.form.DepartmentId.value = VoucherDetails.DefaultStoneDepartment;
                        break;
                }
            });

            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            // **** Set Solitaire Fields ****
            this.form.SubCategoryId.changeSelect2(e => {
                var SubCatDetails = OMS.SubCategoryMasterRow.getLookup().itemById[parseInt(this.form.SubCategoryId.value)];
                this.form.CalcOnId.value = SubCatDetails.CalcOnId.toString();
                this.form.CategoryId.value = SubCatDetails.CategoryId.toString();
                this.form.CalcUnitId.value = SubCatDetails.CalcUnitId.toString();

                this.Setfields();
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item

            (this.form.BOMDetails.view as any).onDataChanged.subscribe(() => {
                if (this.form.ItemTypeId.value == 101)
                    this.CalculateTotals();
            });

        }

        // #region Open Dialog, Close Dialog etc

        protected onDialogOpen() {
            super.onDialogOpen();
            
            this.Setfields();
            this.form.BOMDetails.Pieces = this.form.Pieces.value;
        }

        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.ItemTypeId.value = this.entity.ItemTypeId;
            if (this.entity.ItemTypeId != 101) {
                this.form.UnitRate.value = this.entity.UnitRate;
                if (this.entity.ItemTypeId == 104) {
                    this.form.Purity.value = this.entity.Purity;
                    if (this.form.Purity.value != null)
                        this.form.NetAmount.value = (this.entity.UnitRate * this.entity.Purity) * this.entity.Weight;
                }
                this.form.Pieces.value = this.entity.Pieces;
            }
             
            this.Setfields();

        }
        private Setfields() {
              
            //this.form.ProductId.value == undefined ? this.entity.HasBom = false : this.form.HasBom.value = true;
            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.HasBom); 
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    q.showAndDisableField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);

                    //q.showAndSetRequiredField(this.form.Purity);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.LotNo);


                    //if (this.form.ItemTypeId.value == 0)
                    //    this.form.ItemTypeId.value = 104;

                    //if (this.form.CategoryId.value.length == 0)
                    //    this.form.CategoryId.value = "123";

                    //switch (this.form.ProductTypeId.value) {
                    //    case "5":
                    //        this.form.SubCategoryId.value = "301";
                    //        break;
                    //    case "6":
                    //        this.form.SubCategoryId.value = "302";
                    //        break;
                    //    case "7":
                    //        this.form.SubCategoryId.value = "303";
                    //        break;
                    //}
                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndDisableField(this.form.QualityId);
                    q.showAndDisableField(this.form.SieveId);
                    q.showAndDisableField(this.form.StoneColorId);
                    q.showAndDisableField(this.form.StoneSizeId);
                    q.showAndDisableField(this.form.LotNo);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);

                    q.showAndEnableField(this.form.Pieces);
                    q.showAndEnableField(this.form.Weight);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);
                    this.form.CalcOnId.value = "5";
                    this.form.CalcUnitId.value = "8"

                    //if (this.form.ItemTypeId.value == 0)
                    //    this.form.ItemTypeId.value = 105;

                    switch (parseInt(this.form.CategoryId.value)) {
                        case 1:
                        case 3:
                        case 4:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth);
                            q.hideField(this.form.CertificateNo);
                            //q.hideEditorCategory(this.form.StoneCuletId);
                            break;
                        case 2:
                            q.showAndDisableField(this.form.StoneCutId);
                            q.showAndDisableField(this.form.StonePolishId);
                            q.showAndDisableField(this.form.StoneSymmetryId);
                            q.showAndDisableField(this.form.StoneFluorescenceId);
                            q.showAndDisableField(this.form.StoneCuletId);
                            q.showAndDisableField(this.form.StoneGirdleId);
                            q.showAndDisableField(this.form.StoneTable);
                            q.showAndDisableField(this.form.StoneDepth);
                            q.showAndDisableField(this.form.CertificateNo);
                            q.showAndDisableField(this.form.Pieces);
                            q.showAndDisableField(this.form.Weight);
                            q.showAndDisableField(this.form.Lab);

                            break;
                    }

                    //this.form.SieveId.value = 131;


                    //this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                }
            }
            else {
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.BrandId) : q.showAndSetRequiredField(this.form.BrandId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CollectionId) : q.showAndSetRequiredField(this.form.CollectionId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SuperTypeId) : q.showAndSetRequiredField(this.form.SuperTypeId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductSizeId) : q.showAndSetRequiredField(this.form.ProductSizeId);
                this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                this.form.HasBom.value == true ? q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.form.SKU.value == "0" ? q.showAndEnableField(this.form.Pieces) : q.showAndDisableField(this.form.Pieces);
                this.form.SKU.value == "0" ? this.form.HasBom.value == false ? q.showAndEnableField(this.form.Weight) : q.showAndDisableField(this.form.Weight) : q.showAndDisableField(this.form.Weight)
                this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName, false);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                q.showAndDisableField(this.form.Line_No); 
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneCutId);
                q.hideField(this.form.StonePolishId);
                q.hideField(this.form.StoneSymmetryId);
                q.hideField(this.form.StoneFluorescenceId);
                q.hideField(this.form.StoneCuletId);
                q.hideField(this.form.StoneGirdleId);
                q.hideField(this.form.StoneTable);
                q.hideField(this.form.StoneDepth);
                q.hideField(this.form.LotNo);
            }

            q.showAndDisableField(this.form.ProductCode);
            q.showAndDisableField(this.form.ProductName);
            q.showAndDisableField(this.form.ProductTypeId);
            q.showAndDisableField(this.form.HSN);
            q.showAndDisableField(this.form.TaxCode);

            //q.showAndDisableField(this.form.UnitRate);
        }          
    }
}